import { Route } from '@angular/router';
import { initialDataResolver } from './data-access/services/initial-data.resolver';

export const storesRoutes: Route[] = [
  {
    path: '',
    resolve: {
      initialData: initialDataResolver,
    },
    loadComponent: () => import('./features/main/main.component').then((c) => c.MainComponent),
  },
  {
    path: 'all-categories',
    loadComponent: () => import('./features/all-categories/all-categories.component').then((c) => c.AllCategoriesComponent),
  },
  {
    path: 'promotions/:promotionId',
    loadComponent: () => import('./features/products-list/products-list.component').then((c) => c.ProductsListComponent),
  },
  {
    path: 'search',
    loadComponent: () => import('./features/stores-search/stores-search.component').then((c) => c.StoresSearchComponent),
  },
  {
    path: 'products/:title',
    loadComponent: () => import('./features/products-list/products-list.component').then((c) => c.ProductsListComponent),
  },
  {
    path: 'shopping-guide',
    loadComponent: () => import('./features/shopping-guide/shopping-guide.component').then((c) => c.ShoppingGuideComponent),
  },
  {
    path: 'all-stores',
    loadComponent: () => import('./features/all-stores/all-stores.component').then((c) => c.AllStoresComponent),
  },
  {
    path: 'tag/:tag',
    loadComponent: () => import('./features/store-tag/store-tag.component').then((c) => c.StoreTagComponent),
  },
  {
    path: 'map',
    loadComponent: () => import('./features/store-map/store-map.component').then((c) => c.StoreMapComponent),
  },
  {
    path: ':title',
    loadComponent: () => import('./features/store/store.component').then((c) => c.StoreComponent),
  },
];
